import React, { ReactNode, useState } from 'react';

import * as S from './ThemeLogoIcon.styles';

export const ThemeLogoIcon = ({
  name,
  logo_url,
  isCondensed = false,
  fallbackIcon,
  size,
}: {
  name: string;
  logo_url?: string;
  isCondensed?: boolean;
  fallbackIcon?: ReactNode;
  size?: number;
}) => {
  const [imageError, setImageError] = useState(false);

  return logo_url && !imageError ? (
    <S.StyledLogoImg
      src={logo_url}
      onError={() => setImageError(true)}
      $isCondensed={isCondensed}
      $size={size}
    />
  ) : (
    <>
      {fallbackIcon ?? (
        <S.LogoFallback $isCondensed={isCondensed} $size={size}>
          {name.charAt(0)}
        </S.LogoFallback>
      )}
    </>
  );
};

ThemeLogoIcon.Styled = S;
